import React, { createContext, useContext, useCallback } from "react";

import { useLazyQuery } from "@apollo/client";

import { ME_QUERY } from "../../GraphQlCommon/query";

const CurrentUserUIContext = createContext();

export function useCurrentUserUIContext() {
  return useContext(CurrentUserUIContext);
}

export const CurrentUserUIConsumer = CurrentUserUIContext.Consumer;

export function CurrentUserUIProvider({ children }) {
  const [
    meUser,
    { loading: currentUserLoading, error: currentUserError, data: currentUser },
  ] = useLazyQuery(ME_QUERY, {
    fetchPolicy: "no-cache",
  });

  const setCurrentUser = useCallback(async () => {
    await meUser();
    return true;
  }, []);

  const value = {
    currentUserLoading,
    currentUser,
    setCurrentUser,
    currentUserError,
  };

  return (
    <CurrentUserUIContext.Provider value={value}>
      {children}
    </CurrentUserUIContext.Provider>
  );
}
